import { useCallback, useEffect, useMemo, useState } from "react";
import { getLang } from "../../store/uiStore";

import { getAnalyticsDashboard, getAnalyticsClinics } from "../../api/analytics";

import AnalyticsFilters from "./components/AnalyticsFilters";

import OverviewSection from "./components/OverviewSection";

import ImplementationSection from "./components/ImplementationSection";

import ReportingSection from "./components/ReportingSection";

import RegionsTable from "./components/RegionsTable";

import ReportsRegionsTable from "./components/ReportsRegionsTable";

import IndicatorsSection from "./components/IndicatorsSection";

import IndicatorGeographySection from "./components/IndicatorGeographySection";
import "./Analytics.css";

export default function AnalyticsPage() {
    const lang = getLang();

    const tr = useMemo(() => ({
        loading: lang === "ru" ? "Загрузка..." : "Боргирӣ...",
        title: lang === "ru" ? "Аналитика" : "Таҳлил",
        subtitle: lang === "ru"
            ? "Аналитическая панель мониторинга медицинских учреждений"
            : "Панели таҳлилии мониторинги муассисаҳои тиббӣ",
    }), [lang]);


    const [dashboard, setDashboard] = useState(null);

    const [loading, setLoading] = useState(true);

    const [initialized, setInitialized] = useState(false);
    const [clinicNames, setClinicNames] = useState([]);
    const [clinicNamesLoading, setClinicNamesLoading] = useState(false);
    const [clinicsExpanded, setClinicsExpanded] = useState(false);

    const [filters, setFilters] = useState({
        year: null,
        quarter: null,
        region: null,
        district: null,
        legal_type: null,
        has_inpatient: false,
    });

    // Первая загрузка страницы
    useEffect(() => {
        loadInitialDashboard();
    }, []);

    const loadDashboard = useCallback(async () => {

        try {

            const response = await getAnalyticsDashboard(filters);

            console.log(response.data);

            setDashboard(response.data);

        } catch (error) {

            console.error(error);

        }

    }, [filters]);

    const loadInitialDashboard = async () => {

        try {

            const response = await getAnalyticsDashboard();

            console.log(response.data);

            setDashboard(response.data);

            setFilters({
                year: response.data.filters.current_year,
                quarter: response.data.filters.current_quarter,
                region: null,
                district: null,
                legal_type: null,
                has_inpatient: false,
            });

            setInitialized(true);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    // Скрываем открытый список при изменении фильтров, чтобы он не показывал старые данные.
    useEffect(() => {
        setClinicsExpanded(false);
        setClinicNames([]);
    }, [filters]);

    const toggleClinicNames = async () => {
        if (clinicsExpanded) {
            setClinicsExpanded(false);
            return;
        }

        setClinicsExpanded(true);
        setClinicNamesLoading(true);
        try {
            const response = await getAnalyticsClinics(filters);
            setClinicNames(response.data.results || []);
        } catch (error) {
            console.error("Не удалось загрузить список клиник:", error);
            setClinicNames([]);
        } finally {
            setClinicNamesLoading(false);
        }
    };

    // Обновление после изменения фильтров
    useEffect(() => {

        if (!initialized) {
            return;
        }

        loadDashboard();

    }, [initialized, loadDashboard]);


    if (
        loading ||
        !dashboard ||
        !initialized ||
        !filters.year ||
        !filters.quarter
    ) {
        return <div>{tr.loading}</div>;
    }

    return (

        <div
            className="container-fluid py-4 analytics-page"
            style={{
                background: "#f6f8fb",
                minHeight: "100vh",
            }}
        >

            <div
                className="mb-4 p-4 rounded-4 shadow-sm analytics-page-hero"
                style={{
                    background: "linear-gradient(135deg, #0d6efd 0%, #3b82f6 100%)",
                    color: "#fff",
                }}
            >

                <h2 className="mb-1 fw-bold">

                    {tr.title}

                </h2>

                <div
                    style={{
                        opacity: .9,
                    }}
                >

                    {tr.subtitle}

                </div>

            </div>

            <AnalyticsFilters
                filters={dashboard.filters}
                values={filters}
                onChange={setFilters}
            />

            <OverviewSection
                data={dashboard.kpi}
                clinics={clinicNames}
                clinicsLoading={clinicNamesLoading}
                clinicsExpanded={clinicsExpanded}
                onToggleClinics={toggleClinicNames}
            />

            <ImplementationSection
                data={dashboard.implementation}
            /> 

            <ReportingSection
                data={dashboard.reports}
            />

            <IndicatorsSection
                data={dashboard.indicators}
                quarter={filters.quarter}
                loading={loading}
            /> 

            <IndicatorGeographySection
                data={dashboard.indicators}
                quarter={filters.quarter}
            />

            <ReportsRegionsTable
                regions={dashboard.reports.regions}
            />

            <RegionsTable
                regions={dashboard.implementation.regions}
            /> 

        </div>
    );
}
